<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" xl="2" lg="4" md="3" sm="6">
        <a-range-picker v-model="queryForm.dates" :locale="locale" :allowClear="false" format="YYYY-MM-DD"
          valueFormat="YYYY-MM-DD" style="width:100%;" />
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <a-select v-model="queryForm.postroutelevel" :options="postroutelevels" placeholder="一干/二干" allow-clear
          style="width:100%;">
        </a-select>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="2" sm="6">
        <a-input v-model="queryForm.payinfo" :options="postroutelevels" placeholder="审批单号/付款信息" allow-clear
          style="width:100%;" @keyup.enter="getdata()">
        </a-input>
      </v-col>
      <v-col cols="12" xl="2" lg="2" md="4" sm="6">
        <a-space>
          <a-button @click="getdata()" type="primary">
            查询
          </a-button>
          <a-button @click="getdata('download')" class="btn-cyan">
            <a-icon type="download"></a-icon>下载应付报表
          </a-button>
          <a-button @click="getdata('combinedload')" class="btn-success">
            <a-icon type="download"></a-icon>下载合并明细
          </a-button>
        </a-space>
      </v-col>
    </v-row>
    <a-tabs v-model="queryForm.stag" @change="getdata()">
      <a-tab-pane key="1" tab="待审核"></a-tab-pane>
      <a-tab-pane key="2" tab="已审核"></a-tab-pane>
      <a-tab-pane key="3" tab="未核销"></a-tab-pane>
      <a-tab-pane key="4" tab="已核销"></a-tab-pane>
      <a-tab-pane key="all" tab="全部"></a-tab-pane>
    </a-tabs>
    <div class="tips" style="margin-bottom: 10px;">
      <a-alert message="应付审批流程：结算提交 》业务审核 》财务审核 》财务经理复核 》财务核销" type="info" show-icon />
    </div>
    <v-card>
      <a-table size="small" :columns="headers" :data-source="list" row-key="_id" :pagination="false" bordered
        :locale="{ emptyText: '暂无数据' }" :scroll="{ x: width, y: height }">
        <template slot="number" slot-scope="text, record">
          <span :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.number }}</span>
        </template>
        <template slot="money" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.money }}</p>
        </template>
        <template slot="rmoney" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.rmoney }}</p>
        </template>
        <template slot="omoney" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.omoney }}</p>
        </template>
        <template slot="tmoney" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.tmoney }}</p>
          <v-btn v-if="record._id" small tile text color="primary" @click="showbilllist(record)">下载明细</v-btn>
        </template>
        <template slot="verify_money" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.verify_money }}</p>
          <v-btn v-if="record._id" small tile text color="primary" @click="showverifylist(record)">查看明细</v-btn>
        </template>
        <template slot="left_money" slot-scope="text, record">
          <p :class="{ 'text-h6 error--text': record.number === '合计' }">{{ record.left_money }}</p>
        </template>
        <template slot="state" slot-scope="text, record">
          <!--#regiony业务审核-->
          <p v-if="record.j_review_state === 'waiting'" class="orange--text">业务审核</p>
          <p v-if="record.j_review_state === 'passed'" class="success--text">业务通过</p>
          <!--#endregiony业务审核-->
          <!--#region财务审核-->
          <p v-if="record.c_review_state === 'waiting'" class="orange--text">财务审核</p>
          <p v-if="record.c_review_state === 'passed'" class="success--text">财务通过</p>
          <p v-if="record.c_review_state === 'rejected'" class="error--text">财务驳回</p>
          <!--#endregion财务审核-->
          <!--#region财务经理复核-->
          <p v-if="record.f_review_state === 'waiting'" class="orange--text">财务经理复核</p>
          <p v-if="record.f_review_state === 'passed'" class="success--text">财务经理通过</p>
          <p v-if="record.f_review_state === 'rejected'" class="error--text">财务经理驳回</p>
          <!--#endregion财务经理复核-->
          <!--#region财务核销-->
          <p v-if="record.verify_state === 'waiting'" class="orange--text">财务核销</p>
          <p v-if="record.verify_state === 'finished'" class="success--text">财务已核销</p>
          <!--#endregion财务核销-->
          <v-btn v-if="record.number !== '合计'" text tile small color="primary" @click="showReview(record)"> 查看 </v-btn>
        </template>
        <template slot="payinfo" slot-scope="text, record">
          <p>{{ record.payinfo }}</p>
          <v-btn v-if="record.number !== '合计'" text tile small color="primary" @click="editPayinfo(record)">
            编辑
          </v-btn>
        </template>
        <template slot="remark" slot-scope="text, record">
          <p class="error--text">{{ record.remark }}</p>
          <v-btn v-if="record.number !== '合计'" text tile small color="primary" @click="editRemark(record)">
            编辑
          </v-btn>
        </template>
        <template slot="create_time" slot-scope="text, record">
          <p>{{ record.create_time }}</p>
          <p>{{ record.create_by }}</p>
        </template>
        <template slot="action" slot-scope="text, record">
          <div v-if="username === 'root' && record.number !== '合计'">
            <v-btn small tile text color="error" @click="calcbill(record)"> 计算 </v-btn>
          </div>
          <a-space>
            <a-popconfirm v-if="record.rollbackable" title="撤销应付账单" ok-text="确定" cancel-text="取消"
              @confirm="removebill(record)">
              <v-btn small tile text color="error"> 撤销 </v-btn>
            </a-popconfirm>
            <v-btn v-if="record.reviewable" small tile text color="orange" @click="showReview(record)">
              审核
            </v-btn>
            <template v-if="record.verifyable">
              <v-btn small tile text color="error" @click="showVerify(record)">
                核销
              </v-btn>
              <a-popconfirm v-if="record.verify_finish" title="核销完成" ok-text="确定" cancel-text="取消"
                @confirm="finishVerify(record)">
                <v-btn small tile text color="error"> 核销完成 </v-btn>
              </a-popconfirm>
            </template>
            <a-popconfirm v-if="username === 'root' && record.verify_finished" title="重新核销" ok-text="确定"
              cancel-text="取消" @confirm="reVerify(record)">
              <v-btn small tile text color="error"> 重新核销 </v-btn>
            </a-popconfirm>
          </a-space>
          <v-btn v-if="record.number !== '合计'" small tile text color="#800080" @click="showinvoice(record)">发票账单</v-btn>
        </template>
      </a-table>
    </v-card>
    <v-dialog v-model="verifymodel" persistent max-width="900px">
      <v-card>
        <v-card-title class="primary dark d-flex justify-space-between">
          <span style="color: #fff;">应付账款核销明细</span>
          <v-icon @click="verifymodel = false" class="white--text">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <a-table :columns="verifyheaders" :data-source="verifylist" bordered row-key="_id"
            :pagination="{ hideOnSinglePage: true }" :locale="{ emptyText: '暂无数据' }" size="small">
            <template slot="index" slot-scope="text, record, index">
              {{ index + 1 }}
            </template>
            <template slot="action" slot-scope="text, record">
              <a-popconfirm v-if="record.removeable" title="删除" ok-text="确定" cancel-text="取消"
                @confirm="removeVerify(record._id)">
                <v-btn tile text color="error"> 删除 </v-btn>
              </a-popconfirm>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <a-drawer :visible="reviewModel" :width="500" @close="cancelReview" title="应付账款审核流程" placement="right">
      <a-timeline>
        <!--#region结算提交-->
        <template v-if="reviewList[0]">
          <a-timeline-item color="green">
            <h3>结算提交</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[0].u }} <span style="color:#333;">(提交)</span></span>
              <span style="color:#333;">{{ reviewList[0].t }}</span>
            </div>
          </a-timeline-item>
        </template>
        <!--#endregion结算提交-->
        <!--#region业务审核-->
        <template v-if="reviewList[1]">
          <a-timeline-item color="blue" v-if="reviewList[1].s === 'waiting'">
            <h3>业务审核</h3>
            <h4>{{ reviewList[1].u }} <span style="color:#333;">(待审核)</span></h4>
            <a-form-model v-if="reviewList[1].reviewable" :model="reviewForm" :label-col="labelCol"
              :wrapper-col="wrapperCol">
              <a-form-model-item label="操作">
                <a-radio-group v-model="reviewForm.state">
                  <a-radio value="passed"> 通过 </a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="备注">
                <a-input v-model="reviewForm.remark" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }"
                  placeholder="填写备注或者驳回的原因" />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button @click="cancelReview">取消</a-button>
                <a-button style="margin-left: 8px;" type="primary" @click="saveReview">提交</a-button>
              </a-form-model-item>
            </a-form-model>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[1].s === 'passed'" color="green">
            <h3>业务审核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[1].u }} <span style="color:#333;">(审核通过)</span></span>
              <span style="color:#333;">{{ reviewList[1].t }}</span>
            </div>
            <p>{{ reviewList[1].r }}</p>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[1].s === 'rejected'" color="red">
            <h3>业务审核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[1].u }} <span style="color:#333;">(驳回)</span></span>
              <span style="color:#333;">{{ reviewList[1].t }}</span>
            </div>
            <p>{{ reviewList[1].r }}</p>
          </a-timeline-item>
          <a-timeline-item color="gray" v-else>
            <h3>业务审核</h3>
            <h4>{{ reviewList[1].u }} <span style="color:#333;">(待审核)</span></h4>
          </a-timeline-item>
        </template>
        <!--#endregion业务审核-->
        <!--#region财务审核-->
        <template v-if="reviewList[2]">
          <a-timeline-item color="blue" v-if="reviewList[2].s === 'waiting'">
            <h3>财务审核</h3>
            <h4>{{ reviewList[2].u }} <span style="color:#333;">(待审核)</span></h4>
            <a-form-model v-if="reviewList[2].reviewable" :model="reviewForm" :label-col="labelCol"
              :wrapper-col="wrapperCol">
              <a-form-model-item label="操作">
                <a-radio-group v-model="reviewForm.state">
                  <a-radio value="passed"> 通过 </a-radio>
                  <a-radio value="rejected"> 驳回 </a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="备注">
                <a-input v-model="reviewForm.remark" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }"
                  placeholder="填写备注或者驳回的原因" />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button @click="cancelReview">取消</a-button>
                <a-button style="margin-left: 8px;" type="primary" @click="saveReview">提交</a-button>
              </a-form-model-item>
            </a-form-model>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[2].s === 'passed'" color="green">
            <h3>财务审核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[2].u }} <span style="color:#333;">(审核通过)</span></span>
              <span style="color:#333;">{{ reviewList[2].t }}</span>
            </div>
            <p>{{ reviewList[2].r }}</p>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[2].s === 'rejected'" color="red">
            <h3>财务审核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[2].u }} <span style="color:#333;">(驳回)</span></span>
              <span style="color:#333;">{{ reviewList[2].t }}</span>
            </div>
            <p>{{ reviewList[2].r }}</p>
          </a-timeline-item>
          <a-timeline-item color="gray" v-else>
            <h3>财务审核</h3>
            <h4>{{ reviewList[2].u }} <span style="color:#333;">(待审核)</span></h4>
          </a-timeline-item>
        </template>
        <!--#endregion财务审核-->
        <!--#region财务经理复核-->
        <template v-if="reviewList[3]">
          <a-timeline-item color="blue" v-if="reviewList[3].s === 'waiting'">
            <h3>财务经理复核</h3>
            <h4>{{ reviewList[3].u }} <span style="color:#333;">(待复核)</span></h4>
            <a-form-model v-if="reviewList[3].reviewable" :model="reviewForm" :label-col="labelCol"
              :wrapper-col="wrapperCol">
              <a-form-model-item label="操作">
                <a-radio-group v-model="reviewForm.state">
                  <a-radio value="passed"> 通过 </a-radio>
                  <a-radio value="rejected"> 驳回 </a-radio>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="备注">
                <a-input v-model="reviewForm.remark" type="textarea" :auto-size="{ minRows: 3, maxRows: 5 }"
                  placeholder="填写备注或者驳回的原因" />
              </a-form-model-item>
              <a-form-model-item :wrapper-col="{ span: 14, offset: 4 }">
                <a-button @click="cancelReview">取消</a-button>
                <a-button style="margin-left: 8px;" type="primary" @click="saveReview">提交</a-button>
              </a-form-model-item>
            </a-form-model>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[3].s === 'passed'" color="green">
            <h3>财务经理复核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[3].u }} <span style="color:#333;">(复核通过)</span></span>
              <span style="color:#333;">{{ reviewList[3].t }}</span>
            </div>
            <p>{{ reviewList[3].r }}</p>
          </a-timeline-item>
          <a-timeline-item v-else-if="reviewList[3].s === 'rejected'" color="red">
            <h3>财务经理复核</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[3].u }} <span style="color:#333;">(驳回)</span></span>
              <span style="color:#333;">{{ reviewList[3].t }}</span>
            </div>
            <p>{{ reviewList[3].r }}</p>
          </a-timeline-item>
          <a-timeline-item color="gray" v-else>
            <h3>财务经理复核</h3>
            <h4>{{ reviewList[3].u }} <span style="color:#333;">(待复核)</span></h4>
          </a-timeline-item>
        </template>
        <!--#endregion财务经理复核-->
        <!--#region财务核销-->
        <template v-if="reviewList[4]">
          <a-timeline-item v-if="reviewList[4].s === 'finished'" color="green">
            <h3>财务核销</h3>
            <div style="display:flex;justify-content:space-between;">
              <span>{{ reviewList[4].u }} <span style="color:#333;">(已核销)</span></span>
              <span style="color:#333;">{{ reviewList[4].t }}</span>
            </div>
            <p>{{ reviewList[4].r }}</p>
          </a-timeline-item>
          <a-timeline-item color="gray" v-else>
            <h3>财务核销</h3>
            <h4>{{ reviewList[4].u }} <span style="color:#333;">(待核销)</span></h4>
          </a-timeline-item>
        </template>
        <!--#endregion财务核销-->
      </a-timeline>
    </a-drawer>
    <!--2、财务核销-->
    <v-dialog v-model="verifyModel" persistent max-width="500px">
      <v-form ref="verifyForm" v-model="verifyValid" lazy-validation>
        <v-card>
          <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
            核销应付账款
            <v-icon @click="cancelVerify">mdi-close</v-icon>
          </v-card-title>
          <v-card-text>
            <v-container fluid>
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="verifyForm.amount" label="应付金额" hide-details disabled>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="verifyForm.verify_amount" label="已核销金额" disabled>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field v-model="verifyForm.left_amount" type="number" :rules="[vrules.required]"
                    append-icon="mdi-currency-cny" outlined dense>
                    <template v-slot:label>
                      核销金额<span class="red--text">*</span>
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12">
                  <p>付款时间：</p>
                  <a-date-picker v-model="verifyForm.verify_time" :locale="locale" :show-time="{ format: 'HH:mm:ss' }"
                    placeholder="付款时间" format="YYYY-MM-DD HH:mm:ss" valueFormat="YYYY-MM-DD HH:mm:ss" size="large"
                    :allowClear="false" style="width:100%" />
                </v-col>
                <v-col cols="12">
                  <v-textarea v-model="verifyForm.remark" label="备注" rows="2" outlined dense></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn tile color="primary" @click="saveVerify" :disabled="!verifyValid">提交</v-btn>
            <v-btn tile @click="cancelVerify">关闭</v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="payinfoModel" persistent max-width="500px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          修改付款信息
          <v-icon @click="payinfoModel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="payinfoForm.payinfo" label="付款信息" rows="5" outlined dense></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile color="primary" @click="savePayinfo">提交</v-btn>
          <v-btn tile @click="payinfoModel = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="remarkModel" persistent max-width="500px">
      <v-card>
        <v-card-title class="grey lighten-4 pa-2 text-subtitle-1 mb-4 d-flex justify-space-between">
          修改备注
          <v-icon @click="remarkModel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="remarkForm.remark" label="备注" rows="3" outlined dense></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn tile color="primary" @click="saveRemark">提交</v-btn>
          <v-btn tile @click="remarkModel = false">关闭</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="invoiceModel" persistent max-width="750px">
      <v-card>
        <v-card-title class="grey lighten-4 text-subtitle-1 font-weight-bold d-flex justify-space-between">
          发票及账单
          <v-icon @click="invoiceModel = false">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-row class="mb-2 mt-2">
            <v-col cols="12" class="d-flex">
              <v-file-input v-model="invoiceForm.file" label="发票账单" placeholder="发票账单" persistent-placeholder
                prepend-icon="mdi-file" show-size outlined hide-details dense>
                <template v-slot:selection="{ text }">
                  <v-chip label small color="primary">{{ text }}</v-chip>
                </template>
              </v-file-input>
              <v-btn class="ml-2" color="primary" text tile :disabled="!invoiceForm.file" @click="doupload"> 上传
              </v-btn>
            </v-col>
          </v-row>
          <a-table :columns="invoiceHeaders" bordered :data-source="invoiceList" :pagination="false"
            :locale="{ emptyText: '暂无数据' }" :scroll="{ y: 400 }" size="small">
            <template slot="originalname" slot-scope="text, record">
              <a href="javascript:;" @click="downloadfile(record)">{{ record.originalname }}</a>
            </template>
            <template slot="create_time" slot-scope="text, record">
              {{ record.create_time | dateTime("YYYY-MM-DD HH:mm") }}
            </template>
            <template slot="operation" slot-scope="text, record">
              <a-popconfirm v-if="record.removeable" title="删除发票及账单" ok-text="确定" cancel-text="取消"
                @confirm="removeinvoice(record)">
                <v-btn color="error" text tile>删除</v-btn>
              </a-popconfirm>
            </template>
          </a-table>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import _ from "underscore";
import { mapState } from "vuex";
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';

export default {
  name: "FinanceSelfPayable",
  data() {
    return {
      locale,
      queryForm: {
        dates: [this.$utils.moment().subtract(1, 'month').format('YYYY-MM-DD'), this.$utils.moment().format('YYYY-MM-DD')],
        postroutelevel: undefined,
        payinfo: "",
        stag: '1',
      },
      postroutelevels: [
        { value: '一级', label: '一干' },
        { value: '二级', label: '二干' },
      ],
      headers: [
        { title: "项目", dataIndex: "postroutelevel", scopedSlots: { customRender: "postroutelevel" }, width: 80, align: "center" },
        { title: "审批单号", dataIndex: "number", scopedSlots: { customRender: "number" }, width: 100, align: "center" },
        { title: "应付运费", dataIndex: "money", scopedSlots: { customRender: "money" }, width: 150, align: "center" },
        { title: "应付押金", dataIndex: "rmoney", scopedSlots: { customRender: "rmoney" }, width: 120, align: "center" },
        { title: "应付油卡", dataIndex: "omoney", scopedSlots: { customRender: "omoney" }, width: 120, align: "center" },
        { title: "应付金额", dataIndex: "tmoney", scopedSlots: { customRender: "tmoney" }, width: 150, align: "center" },
        // { title: "差异金额", dataIndex: "dmoney", scopedSlots: { customRender: "dmoney" }, width: 100, align: "center" },
        // { title: "实付金额", dataIndex: "rtmoney", scopedSlots: { customRender: "rtmoney" }, width: 150, align: "center" },
        { title: "核销金额", dataIndex: "verify_money", scopedSlots: { customRender: "verify_money" }, width: 150, align: "center" },
        { title: "付款时间", dataIndex: "verify_time", scopedSlots: { customRender: "verify_time" }, width: 120, align: "center" },
        { title: "剩余金额", dataIndex: "left_money", scopedSlots: { customRender: "left_money" }, width: 150, align: "center" },
        { title: "状态", dataIndex: "state", scopedSlots: { customRender: "state" }, width: 150, align: "center" },
        { title: "付款信息", dataIndex: "payinfo", scopedSlots: { customRender: "payinfo" }, width: 150, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 150, align: "center" },
        { title: "创建时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 180, align: "center", fixed: "right" },
      ],
      list: [],
      height: 600,
      verifymodel: false,
      verifyquery: {},
      verifylist: [],
      verifyheaders: [
        { title: "序号", dataIndex: "index", scopedSlots: { customRender: "index" }, width: 80, align: "center" },
        { title: "金额", dataIndex: "amount", scopedSlots: { customRender: "amount" }, width: 120, align: "center" },
        { title: "付款时间", dataIndex: "time", scopedSlots: { customRender: "time" }, width: 120, align: "center" },
        { title: "操作人", dataIndex: "opuser", scopedSlots: { customRender: "opuser" }, width: 120, align: "center" },
        { title: "操作时间", dataIndex: "optime", scopedSlots: { customRender: "optime" }, width: 120, align: "center" },
        { title: "备注", dataIndex: "remark", scopedSlots: { customRender: "remark" }, width: 150, align: "center" },
        { title: "操作", dataIndex: "action", scopedSlots: { customRender: "action" }, width: 120, align: "center" },
      ],
      reviewModel: false,
      reviewForm: {},
      reviewValid: true,
      reviewList: [
        { s: "waiting", u: "", t: "", r: "", },
        { s: "waiting", u: "", t: "", r: "", },
        { s: "waiting", u: "", t: "", r: "", },
        { s: "waiting", u: "", t: "", r: "", },
        { s: "waiting", u: "", t: "", r: "", },
      ],
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      invoiceModel: false,
      invoiceForm: {},
      invoiceList: [],
      invoiceHeaders: [
        { title: "文件名", dataIndex: "originalname", scopedSlots: { customRender: "originalname" }, width: 300, },
        { title: "上传人", dataIndex: "create_by", scopedSlots: { customRender: "create_by" }, width: 100, },
        { title: "上传时间", dataIndex: "create_time", scopedSlots: { customRender: "create_time" }, width: 160, },
        { title: "操作", dataIndex: "operation", scopedSlots: { customRender: "operation" }, width: 120, },
      ],
      verifyModel: false,
      verifyForm: {},
      verifyValid: true,
      verifyMenu: false,
      vrules: {
        required: (value) => !!value || "不能为空"
      },
      remarkModel: false,
      remarkForm: {},
      payinfoModel: false,
      payinfoForm: {},
    };
  },
  computed: {
    ...mapState(["role", "username"]),
    width() {
      return _.reduce(this.headers, (a, b) => a + (b.width || 300), 0);
    },
  },
  components: {},
  watch: {},
  mounted() {
    this.height = window.innerHeight - 300;
    window.onresize = (e) => {
      console.log("onresize", window.innerHeight);
      this.height = window.innerHeight - 300;
    };
    this.getdata();
  },
  activated() {
  },
  methods: {
    getdata(action) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/list", { ...this.queryForm, action }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          if (action === 'download') return this.$download(res.data.url, res.data.name);
          let list = res.data.list.map(n => {
            return {
              ...n,
              money: this.$utils.formatMoney(n.amount, 2, ''),
              rmoney: this.$utils.formatMoney(n.ramount, 2, ''),
              omoney: this.$utils.formatMoney(n.oamount, 2, ''),
              tmoney: this.$utils.formatMoney(n.total, 2, ''),
              dmoney: this.$utils.formatMoney(n.diff, 2, ''),
              rtmoney: this.$utils.formatMoney(n.rtotal, 2, ''),
              verify_money: this.$utils.formatMoney(n.verify_amount, 2, ''),
              left_money: this.$utils.formatMoney(n.left_amount, 2, ''),
            }
          });
          list.unshift(list[list.length - 1]);
          list.splice(list.length - 1)
          this.list = list;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showbilllist(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/billlist", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$download(res.data.url, res.data.name);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showverifylist(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/verifylist", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.verifyquery = item;
          this.verifylist = res.data.list;
          this.verifymodel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    removebill(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/remove", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    calcbill(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/calc", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.$alert(`
            <span>应付运费：${res.data.amount}</span>
            <span>应付押金：${res.data.ramount}</span>
            <span>应付油卡：${res.data.oamount}</span>
            <span>应付金额：${res.data.total}</span>
          `)
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    ///审批流程/节点明细
    showReview(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/showreview", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.reviewList = res.data.list;
          this.reviewForm = {
            selfpaybillid: item._id,
            state: "passed",
            remark: "同意",
          };
          this.reviewModel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    saveReview() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/savereview", { reviewForm: this.reviewForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.reviewModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelReview() {
      this.reviewModel = false;
    },
    showVerify(item) {
      console.log('showVerify', item)
      this.verifyForm = {
        selfpaybillid: item._id,
        amount: item.rtotal,
        verify_amount: item.verify_amount,
        left_amount: item.left_amount,
        verify_time: '',//this.$utils.dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss'),
        remark: "",
      };
      this.verifyModel = true;
    },
    saveVerify() {
      if (!this.$refs.verifyForm.validate()) return;
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/saveverify", { verifyForm: this.verifyForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.verifyModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    cancelVerify() {
      this.$refs.verifyForm.resetValidation();
      this.verifyModel = false;
    },
    removeVerify(_id) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/removeverify", { _id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.showverifylist(this.verifyquery);
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    finishVerify(item) {
      let data = {
        selfpaybillid: item._id,
      };
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/finishverify", data).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    reVerify(item) {
      let data = {
        selfpaybillid: item._id,
      };
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/reverify", data).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    editRemark(item) {
      this.remarkForm = {
        selfpaybillid: item._id,
        remark: item.remark,
      };
      this.remarkModel = true;
    },
    saveRemark() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/saveremark", { dataForm: this.remarkForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.remarkModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    editPayinfo(item) {
      this.payinfoForm = {
        selfpaybillid: item._id,
        payinfo: item.payinfo,
      };
      this.payinfoModel = true;
    },
    savePayinfo() {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/savepayinfo", { dataForm: this.payinfoForm }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.payinfoModel = false;
          this.getdata();
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    showinvoice(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/showinvoice", item).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.invoiceList = res.data.list;
          this.invoiceForm = {
            selfpaybillid: item._id,
            file: null,
          };
          this.invoiceModel = true;
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    removeinvoice(item) {
      this.$toast.loading({ message: "" });
      this.$api.doAPI("/selfpayable/removeinvoice", { _id: item._id }).then((res) => {
        this.$toast.clear();
        if (res.code === 0) {
          this.showinvoice(this.invoiceForm);
        }
        else {
          this.$alert(res.msg);
        }
      }).catch((err) => {
        this.$toast.clear();
        console.error(err);
      });
    },
    checkfile(file) {
      if (!file) {
        this.$alert("文件不能为空");
        return { code: 1 };
      }
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$alert("文件不能超过10MB");
        return { code: 1 };
      }
      return { code: 0 };
    },
    async doupload() {
      let checkresult = this.checkfile(this.invoiceForm.file);
      if (checkresult.code !== 0) return;
      this.$toast.loading({ message: "" });
      let file = this.invoiceForm.file;
      const slicefiles = this.$utils.sliceFile(file.size);
      const faid = this.$utils.uuid();
      for (let j = 0; j < slicefiles.length; j++) {
        let slicefile = slicefiles[j];
        const formData = new FormData();
        if (slicefile.chunks > 1) {
          let _file = file.slice(slicefile.from, slicefile.to);
          formData.set("file", _file);
        }
        else {
          formData.set("file", file);
        }
        formData.set("faid", faid);
        formData.set("chunk", slicefile.chunk);
        formData.set("chunks", slicefile.chunks);
        formData.set("originalname", file.name);
        formData.set("selfpaybillid", this.invoiceForm.selfpaybillid);
        try {
          let res = await this.$api.doUpload("/selfpayable/plupload", formData);
          if (res.code === 0) {
            if (slicefile.chunk + 1 === slicefile.chunks) {
              this.$toast.clear();
              this.invoiceForm.file = null;
            }
          }
          else {
            this.$toast.clear();
            this.$alert(res.msg);
            break;
          }
        } catch (e) {
          console.error(e);
          this.$toast.clear();
          this.$alert(e.message);
          break;
        }
      }
      this.showinvoice(this.invoiceForm);
    },
    downloadfile(item) {
      this.$download(item.remoteurl, item.originalname);
    },
  },
};
</script>
<style lang="less" scoped>
p {
  margin: 0;
}

/deep/ .row {
  margin-bottom: 0 !important;
}

/deep/ .row+.row {
  margin-top: 0;
}

/deep/ .col,
.col-12 {
  padding-bottom: 0 !important;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-scroll>.ant-table-body>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-small>.ant-table-content>.ant-table-fixed-right>.ant-table-body-outer>.ant-table-body-inner>table>.ant-table-tbody>tr>td {
  padding: 0;
}

/deep/ .ant-table-fixed-header .ant-table-scroll .ant-table-header {
  padding-bottom: 4px;
}
</style>
